// Single-SPA parcel entrypoint per ADR-MF02 / frontend-structure.md §6.2.
import singleSpaVue from 'single-spa-vue';
import { createApp, h } from 'vue';
import { createPinia } from 'pinia';
import ToastService from 'primevue/toastservice';
import ConfirmationService from 'primevue/confirmationservice';

import App from '@/shell/App.vue';
import { installGlobalErrorHandlers } from '@/shell';
import { createShellRouter } from '@/shell/router';
import { installTheme } from '@/shell/theme';

window.addEventListener('vite:preloadError', (e: Event) => {
  const url = (e as Event & { payload?: Error }).payload?.message ?? '';
  const key = `admin-web:preload-reload:${url}`;
  if (sessionStorage.getItem(key) === '1') return;
  sessionStorage.setItem(key, '1');
  window.location.reload();
});

const lifecycles = singleSpaVue({
  createApp,
  appOptions: {
    render: () => h(App),
  },
  handleInstance(app) {
    installGlobalErrorHandlers(app);
    app.use(createPinia());
    app.use(createShellRouter());
    installTheme(app);
    app.use(ToastService);
    app.use(ConfirmationService);
  },
});

export const bootstrap = lifecycles.bootstrap;
export const mount = lifecycles.mount;
export const unmount = lifecycles.unmount;
